import Vue from "vue";
import Vuex from "vuex";
import { GetCategories, ChangeCategoryStatus, GetStates } from "../End Points/api";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: localStorage.getItem("token") || null,
    categories: [], 
    states: []
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
      if (token) {
        localStorage.setItem("token", token);
      } else {
        localStorage.removeItem("token");
      }
    },
    LOGOUT(state) {
      state.token = null;
      localStorage.removeItem("token");
    },
    SET_CATEGORIES(state, categories) {
      state.categories = categories;
    },
    SET_STATES(state, states) { 
      state.states = states;
    },
    UPDATE_CATEGORY_STATUS(state, { id, is_active }) {
      const category = state.categories.find((cat) => cat.id === id);
      if (category) {
        category.is_active = is_active;
      }
    }
  },
  actions: {
    login({ commit }, token) {
      commit("SET_TOKEN", token);
    },
    logout({ commit }) {
      commit("LOGOUT");
    },
    async fetchStates({ commit }) {
      try {
        const res = await GetStates();
        if (res.status === 200 && res.data.success) {
          commit("SET_STATES", res.data.data);  
        } else {
          console.error("Unexpected API response:", res.data);
        }
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    },
    async fetchCategories({ commit }) {
      try {
        const res = await GetCategories();
        if (res.status === 200 && res.data) {
          commit("SET_CATEGORIES", res.data);
        } else {
          console.error("Unexpected API response:", res.data);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    },
    async toggleCategoryStatus({ commit }, category) {
      try {
        const newStatus = !category.is_active;
        const response = await ChangeCategoryStatus(category.id, newStatus);
        if (response.status === 200) {
          commit("UPDATE_CATEGORY_STATUS", { id: category.id, is_active: newStatus });
        } else {
          console.error("Failed to update status", response);
        }
      } catch (error) {
        console.error("Error changing category status:", error);
      }
    }
  },
  getters: {
    isAuthenticated: (state) => !!state.token,
    allCategories: (state) => state.categories,
    allStates: (state) => state.states
  }
});
